export const APPLICATION_NAME = 'UserTenantOnboarding';
export const TENANTLESS = 'tenantless';
export const JWEB_SIGNIN_REQUEST_ID = 'CLIENTOS_SIGNIN_REQUEST_ID';
